/* This div is just used as a ref, but some peanut styling is forcing 100% width
and height, so we wrap it in 0px by 0px div */
.quote-script-container {
    height: 0%;
    width: 0%;
}

.table {
    min-height: calc(100% - 48px); /* 48px is the height of the ListPageControlBar */
}
